// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-61e95bee] .leader-data .el-form .is-disabled * {\r\n  color: blue !important;\n}\n[data-v-61e95bee] .el-upload .el-button {\r\n  display: none !important;\n}\n[data-v-61e95bee] .el-upload-list__item-status-label {\r\n  display: none !important;\n}\n[data-v-61e95bee] .el-icon-close {\r\n  display: none !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
